.rate-column {
  width: 100%;
  text-align: right;
}

.rate-error-wrapper {
  height: 100%;
  display: flex;
  flex-direction: row-reverse;
}
